import React, { type ReactNode } from 'react';

import { useIntl } from 'react-intl-next';

import { useDefaultCatch } from '@atlassian/eoc-catch';
import { useFlags } from '@atlassian/eoc-global-context';

import { ResponderNamesContainer } from '../responder-names-store';

interface WrapperProps {
	children: ReactNode;
	isGlobal?: boolean;
	scope?: string | undefined;
}

/**
 * Wrapper should live on the root level since it uses glocal scoped container.
 */
const ResponderNamesWrapper = ({ scope, isGlobal = true, children }: WrapperProps) => {
	const flagApi = useFlags();
	const intl = useIntl();
	const defaultCatch = useDefaultCatch();

	if (scope) {
		return (
			<ResponderNamesContainer
				flagApi={flagApi}
				intlApi={intl}
				scope={scope}
				defaultCatch={defaultCatch}
				displayName="ResponderNamesWrapper"
			>
				{children}
			</ResponderNamesContainer>
		);
	}

	return (
		<ResponderNamesContainer
			flagApi={flagApi}
			intlApi={intl}
			isGlobal={isGlobal}
			defaultCatch={defaultCatch}
			displayName="ResponderNamesWrapper"
		>
			{children}
		</ResponderNamesContainer>
	);
};
export default ResponderNamesWrapper;
